import { render, staticRenderFns } from "./HrPayrollList.vue?vue&type=template&id=7f9c7c2e&lang=pug&"
import script from "./HrPayrollList.vue?vue&type=script&lang=js&"
export * from "./HrPayrollList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "HrPayrollList.vue"
export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VDialog } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
installComponents(component, {
  VBtn,
  VDialog,
  VIcon,
})
